export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/';
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const KEY = '0050f6cc-382d-4910-8364-1002a9c3e6e5';
export const MODAL_CLOSE_SEC = 2.5;
